module.exports = __webpack_public_path__ + "img/edit_event_step3_off.5af3e8ee.png";